import { LocationFilter } from "@/types/dto/search-filters/location-filter";
import { v4 as uuidv4 } from "uuid";

export const locationFilterFactory = (data: any = {}): LocationFilter => ({
  id: data.id || uuidv4(),
  fieldName: data.locationType || "",
  value: data.locationName || "",
  displayName: data.locationName || ""
} as LocationFilter);

export const locationFiltersFactory = (dataArray: any[] = []): LocationFilter[] =>
  dataArray.map(locationFilterFactory);

export default locationFilterFactory;